/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  GeneratedMessage,
  TestAssignmentStatusSMSRequest,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useTestTestGenerateAssignmentStatusSMSHook = () => {
  const testTestGenerateAssignmentStatusSMS =
    useCustomInstance<GeneratedMessage[]>();

  return useCallback(
    (
      testAssignmentStatusSMSRequest: TestAssignmentStatusSMSRequest,
      signal?: AbortSignal
    ) => {
      return testTestGenerateAssignmentStatusSMS({
        url: `/api/Test/TestGenerateAssignmentStatusSMS`,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        signal,
      });
    },
    [testTestGenerateAssignmentStatusSMS]
  );
};

export const getTestTestGenerateAssignmentStatusSMSQueryKey = (
  testAssignmentStatusSMSRequest: TestAssignmentStatusSMSRequest
) => {
  return [
    `/api/Test/TestGenerateAssignmentStatusSMS`,
    testAssignmentStatusSMSRequest,
  ] as const;
};

export const useTestTestGenerateAssignmentStatusSMSQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useTestTestGenerateAssignmentStatusSMSHook>>
  >,
  TError = unknown,
>(
  testAssignmentStatusSMSRequest: TestAssignmentStatusSMSRequest,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useTestTestGenerateAssignmentStatusSMSHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTestTestGenerateAssignmentStatusSMSQueryKey(
      testAssignmentStatusSMSRequest
    );

  const testTestGenerateAssignmentStatusSMS =
    useTestTestGenerateAssignmentStatusSMSHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useTestTestGenerateAssignmentStatusSMSHook>>
    >
  > = ({ signal }) =>
    testTestGenerateAssignmentStatusSMS(testAssignmentStatusSMSRequest, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useTestTestGenerateAssignmentStatusSMSHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TestTestGenerateAssignmentStatusSMSQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useTestTestGenerateAssignmentStatusSMSHook>>
  >
>;
export type TestTestGenerateAssignmentStatusSMSQueryError = unknown;

export const useTestTestGenerateAssignmentStatusSMS = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useTestTestGenerateAssignmentStatusSMSHook>>
  >,
  TError = unknown,
>(
  testAssignmentStatusSMSRequest: TestAssignmentStatusSMSRequest,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useTestTestGenerateAssignmentStatusSMSHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useTestTestGenerateAssignmentStatusSMSQueryOptions(
    testAssignmentStatusSMSRequest,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
